import React, { Fragment } from 'react'
import * as R from 'ramda'
import Seo from '@components/Seo'
import HireCategory from '@components/HireCategory'
import ContactDetails from '@components/ContactDetails'

const HireCategoryPage = ({ data }) => {
  const metaTitle = R.pathOr('', ['contentfulPage', 'metaTitle'], data)
  const metaDescription = R.pathOr('', ['contentfulPage', 'metaDescription'], data)
  const canonicalUrl = R.pathOr('', ['contentfulPage', 'canonicalUrl'], data)
  const category = R.pathOr('', ['contentfulPage', 'template', '0', 'category'], data)
  const contactDetails = R.pathOr(null, ['contentfulPage', 'template', '0', 'contactDetails'], data)
  const allContentfulPage = R.prop('allContentfulPage', data)
  let products = R.pathOr([], ['allContentfulPage', 'edges'], data)

  if (allContentfulPage) {
    products = R.filter(({ node }) => R.equals(R.path(['template', '0', 'category'], node), category), products)
  }

  return (
    <Fragment>
      <Seo
        title={metaTitle}
        canonicalUrl={canonicalUrl}
        description={metaDescription}
      />
      <HireCategory category={category} products={products} />
      {contactDetails && <ContactDetails data={contactDetails} />}
    </Fragment>
  )
}

export const query = graphql`
query HireCategoryQuery($slug: String) {
  contentfulPage(slug: {eq: $slug}) {
    title
    metaTitle
    canonicalUrl
    metaDescription
    slug
    template {
      ... on ContentfulHireCategoryTemplate {
        title
        category
        contactDetails {
          instruction
          phone
          email
          callback
          hours
          excluding
        }
      }
    }
  }
  allContentfulPage(filter: {
    template: {
      internal: {
        type: {
          eq: "ContentfulProductTemplate"
        }
      }
    } 
  }) {
    edges {
      node {
        ... on ContentfulPage {
          title
          slug
          template {
            ... on ContentfulProductTemplate {
              title
              image {
                sizes {
                  src
                }
              }
              category
              brand
            }
          }
        }
      }
    }
  }
}
`

export default HireCategoryPage



// WEBPACK FOOTER //
// ./src/templates/hireCategory.js